import { render, staticRenderFns } from "./house-of-the-hungarian-millennium.vue?vue&type=template&id=6479b2c4&scoped=true&"
import script from "./house-of-the-hungarian-millennium.vue?vue&type=script&lang=js&"
export * from "./house-of-the-hungarian-millennium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6479b2c4",
  null
  
)

export default component.exports